import { useCallback, useState } from 'react';
import LineHorizontal from '@lemon8/design/lib/icons/icon_assets/line_horizontal.svg';
import XMark from '@lemon8/design/lib/icons/icon_assets/x_mark.svg';
import cls from 'classnames';
import { useLegalList } from '~/utils/legal-list';
import { MenuLanguageSelector } from './menu-language-selector';
import { useSetAtom } from 'jotai';
import { $SharePanel } from '~/model';
import { EClickPosition } from '~/utils/click-position';
import { useTranslation } from 'react-i18next';

import './style.scss';

interface ILegalMenu {
  className?: string;
  right?: number;
}

const COPYRIGHT: string = '©2025 Heliophilia Pte. Ltd. All Rights Reserved.';

export const LegalMenu = (props: ILegalMenu) => {
  const { className, right } = props;
  const legals = useLegalList();
  const setSharePanel = useSetAtom($SharePanel);
  const { t } = useTranslation();
  const [open, setOpen] = useState<boolean>(false);
  const closed = !open;

  const handleButtonClick = useCallback(() => {
    window.Tea('wap_click', {
      current_position: EClickPosition.TOP_BAR_SIDE,
      is_cta: 0,
    });
    setOpen(true);
  }, []);

  const handleContentClick = useCallback(() => {
    setOpen(false);
  }, []);

  const handleLegalClick = useCallback(
    (position: string) => () => {
      window.Tea('wap_click', {
        current_position: position,
        is_cta: 0,
      });
    },
    [],
  );

  const handleShareClick = useCallback(() => {
    window.Tea('wap_click', {
      current_position: EClickPosition.TOP_BAR_SHARE,
      is_cta: 0,
    });
    setSharePanel(true);
  }, [setSharePanel]);

  return (
    <>
      <button className={cls(className, 'legal_button')} onClick={handleButtonClick}>
        <LineHorizontal />
      </button>
      <div className={cls('legal_panel', { open, closed })}>
        <ul className={cls('legal_panel_content', { open, closed })} style={{ right: `${right || 0}px` }}>
          <MenuLanguageSelector />
          <li className="legal_panel_item" onClick={handleShareClick}>
            {t('seo_sideBar_share')}
          </li>
          {legals.map((l) => (
            <li className={'legal_panel_item'} key={l.displayName}>
              <a href={l.href} target="_blank" onClick={handleLegalClick(l.clickPosition)}>
                {l.displayName}
              </a>
            </li>
          ))}
        </ul>
        <button className={'legal_panel_close'} onClick={handleContentClick}>
          <XMark />
        </button>
        {/*<p className="legal_panel_copyright">{COPYRIGHT}</p>*/}
      </div>
    </>
  );
};
